var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#fb0",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 27.347,
    height: 24.078,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_338",
    "data-name": "Groupe 338",
    transform: "translate(-18.997 -2672.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_43",
    "data-name": "Groupe de masques 43",
    transform: "translate(18.997 2672.432)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#fb0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_259",
    "data-name": "Groupe 259",
    transform: "translate(32.959 2692.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_258",
    "data-name": "Groupe 258",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_365",
    "data-name": "Trac\\xE9 365",
    d: "M0,.528A26.907,26.907,0,0,1,5.589,0c3.058,0,5.026.527,6.468,1.722a4.992,4.992,0,0,1,2,4.183,5.6,5.6,0,0,1-4.007,5.2v.105a6.035,6.035,0,0,1,4.886,5.905A6.228,6.228,0,0,1,12.9,21.865c-1.617,1.511-4.288,2.214-8.155,2.214A35.747,35.747,0,0,1,0,23.8Zm3.058,9.7H5.835c3.2,0,5.1-1.722,5.1-4.007,0-2.742-2.074-3.867-5.167-3.867a13.119,13.119,0,0,0-2.707.211Zm0,11.318a16.631,16.631,0,0,0,2.566.141c3.164,0,6.081-1.16,6.081-4.6,0-3.2-2.777-4.57-6.116-4.57H3.058Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_366",
    "data-name": "Trac\\xE9 366",
    d: "M245.946,90.659c0-2-.035-3.726-.141-5.308h2.707l.141,3.374h.105A5.145,5.145,0,0,1,253.5,85a6.3,6.3,0,0,1,.844.07v2.918a4.814,4.814,0,0,0-1.055-.07c-2.179,0-3.726,1.617-4.148,3.937a9.253,9.253,0,0,0-.105,1.441v9.069h-3.093Z",
    transform: "translate(-227 -78.497)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Brome",
    d: "M1.694,8.132a.236.236,0,0,1-.044,0A.205.205,0,0,1,1.572,8.1a.231.231,0,0,1-.034-.028Q1.475,8,1.475,7.913V1.957q0-.1.064-.165t.156-.064H4.347q.741,0,1.208.224t.691.618q.224.393.224.915,0,.348-.124.608t-.3.425q-.178.165-.352.256.357.165.631.549t.274.915q0,.549-.247.979t-.732.672q-.485.242-1.2.242Zm1.052-.97H4.274q.494,0,.75-.27t.256-.654q0-.4-.261-.668t-.746-.265H2.746Zm0-2.809H4.183q.485,0,.727-.233t.242-.608q0-.384-.242-.6T4.183,2.7H2.746ZM7.86,8.132a.236.236,0,0,1-.044,0A.205.205,0,0,1,7.739,8.1.231.231,0,0,1,7.7,8.068Q7.641,8,7.641,7.913V3.6q0-.1.064-.165t.156-.064H8.6q.091,0,.16.064T8.83,3.6v.375q.21-.293.544-.448t.773-.156h.375q.1,0,.16.064t.059.156v.659q0,.091-.059.156t-.16.064H9.809q-.439,0-.682.247T8.885,5.4V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm5.636.091q-.732,0-1.23-.256t-.759-.723q-.261-.467-.3-1.089-.009-.165-.009-.4t.009-.4q.037-.631.306-1.093t.768-.718q.5-.256,1.212-.256t1.212.256q.5.256.768.718t.306,1.093q.009.165.009.4t-.009.4q-.037.622-.3,1.089t-.759.723Q14.228,8.224,13.5,8.224Zm0-.906q.485,0,.75-.306t.293-.9q.009-.137.009-.357T14.539,5.4q-.027-.586-.293-.9t-.75-.311q-.485,0-.75.311t-.293.9q-.009.137-.009.357t.009.357q.027.595.293.9T13.5,7.318Zm3.531.814a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.595q0-.091.064-.156t.156-.064h.714q.091,0,.156.064t.064.156v.311q.192-.256.517-.435t.773-.188q1.043-.018,1.455.814.21-.366.608-.59t.883-.224q.476,0,.865.22t.613.663q.224.444.224,1.121V7.913q0,.091-.064.156A.231.231,0,0,1,23.8,8.1a.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0h-.75a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V5.36q0-.412-.119-.654t-.32-.343q-.2-.1-.448-.1-.2,0-.4.1t-.329.343q-.128.242-.128.654V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0h-.75a.273.273,0,0,1-.048,0,.216.216,0,0,1-.043-.012.191.191,0,0,1-.037-.02.2.2,0,0,1-.032-.028q-.059-.064-.059-.156V5.36q0-.412-.128-.654t-.329-.343q-.2-.1-.43-.1-.21,0-.412.105t-.329.343q-.128.238-.128.65V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm10.082.091q-1.016,0-1.61-.586t-.64-1.665q-.009-.091-.009-.233t.009-.224q.037-.686.316-1.189t.773-.773q.494-.27,1.162-.27.741,0,1.244.306t.759.851q.256.544.256,1.258v.192q0,.091-.064.156t-.165.064H26.1t0,.027q0,.027,0,.046.009.32.124.59t.339.435q.224.165.535.165.256,0,.43-.078t.284-.178q.11-.1.156-.165.082-.11.133-.133t.151-.023h.787q.091,0,.151.055t.05.137q-.009.146-.151.357t-.407.412q-.265.2-.663.334T27.109,8.224ZM26.1,5.342h2.022V5.315q0-.357-.119-.622t-.348-.421q-.229-.156-.549-.156t-.549.156q-.229.156-.343.421t-.114.622Z",
    transform: "translate(29.919 2676.404)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrome);
export default __webpack_public_path__ + "static/media/BROME.41b4a75961bc44bfc34e587a2f640414.svg";
export { ForwardRef as ReactComponent };